/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} License_TypeInputs */

const en_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`License type: ${i?.type}`)
};

const fr_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type de licence : ${i?.type}`)
};

const de_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lizenztyp: ${i?.type}`)
};

const it_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo di licenza: ${i?.type}`)
};

const ru_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тип лицензии: ${i?.type}`)
};

const es_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo de licencia: ${i?.type}`)
};

const zh_cn2_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`许可证类型：${i?.type}`)
};

const ja_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ライセンスタイプ: ${i?.type}`)
};

const hi_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लाइसेंस प्रकार: ${i?.type}`)
};

const pt_pt2_license_type = /** @type {(inputs: License_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo de licença: ${i?.type}`)
};

/**
* | output |
* | --- |
* | "License type: {type}" |
*
* @param {License_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_type = /** @type {((inputs: License_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_license_type(inputs)
	if (locale === "de") return de_license_type(inputs)
	if (locale === "it") return it_license_type(inputs)
	if (locale === "ru") return ru_license_type(inputs)
	if (locale === "es") return es_license_type(inputs)
	if (locale === "zh-CN") return zh_cn2_license_type(inputs)
	if (locale === "ja") return ja_license_type(inputs)
	if (locale === "hi") return hi_license_type(inputs)
	if (locale === "pt-PT") return pt_pt2_license_type(inputs)
	return en_license_type(inputs)
});